module.exports = __webpack_public_path__ + "static/img/insurance-aseaa.2dd7df0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/insurance-aseaa.jpg
// module id = sj0j
// module chunks = 4